var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((7),function(i){return _c('v-flex',{key:`3${i}`,attrs:{"xs3":""}},[_c('v-card',{staticClass:"card"},[_c('v-card-text')],1)],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }